/* eslint-disable */ 

import React, { useState, useEffect, useRef } from "react"
import elasticlunr from "elasticlunr"
import * as JsSearch from 'js-search';
import { Link } from "gatsby"

import { useStaticQuery, graphql } from "gatsby"
import frontmatter from "front-matter"

import Modal from "./Modal"

import searchStyles from "./search.module.css"

export default function Search({jsonDataSource}) {

    const siteMdxData = useStaticQuery(graphql`
        query {         
            allMdx {
                nodes {
                  slug
                  rawBody
                  frontmatter {
                    post_title
                    redirect
                  }
                }
            }                       
        }
    `)    


    const [query, setQuery] = useState('')
    const [results, setResults] = useState([])

    const [showModal, setShowModal] = useState(false)

    // flatten the Tree for search index
    // 1st we add only info for Transcoding
    let jsonDataArray  = []

    // there can be different JSON data sources, now we only filter for transcoding
    // because each data source may have its own data structure
    // and data for seach index must be prepared based on that

    // SEARCH SECTIONS
    // api-reference   Api References
    // tutorials       Tutorials
    // faq             FAQ
    // support         don't add to search index

    const indexData = [
        {
            nodeName: 'transcoding',
            transcodingPrefix: '/api-reference/transcoding/',
            transcodingIndexIdPrefix: 'transcoding_section_'            
        },

        {
            nodeName: 'streaming',
            transcodingPrefix: '/api-reference/streaming/',
            transcodingIndexIdPrefix: 'streaming_section_'            
        }        
    ]


    let prefix = null

    let contentJSON 

    let nodeJSON 
    
    if(jsonDataSource){

        indexData.forEach(({nodeName, transcodingPrefix, transcodingIndexIdPrefix}) => {

            prefix = transcodingPrefix
            nodeJSON = jsonDataSource.edges.filter( ({node}) => node.name === nodeName)[0] 
            contentJSON = nodeJSON.node.content

            contentJSON.forEach(({ title, description, name, method, version, method_arguments, return_object, input_objects, output_objects }, sectionIndex) => {

                const http_method = method
                const api_method = `/${version}/${name}`
    
                jsonDataArray.push({
                    id: `${transcodingIndexIdPrefix}${sectionIndex}`,
                    title: title,
                    slug: `${prefix}#${title.toLowerCase().split(' ').join('-')}`,
                    content: description.replace(/<[^>]+>/g, ''),              
                    prefix: prefix,
                    type: "section",
                    http_method: http_method,
                    method:api_method,
                    var_type:'',
                    required:'',
                    section: 'Api References'
                })
             
    
                let methodName = name

                // remove /<>
                if(methodName){
                    //console.log("methodName in search: ", methodName)
                    let formatedMethodName = methodName.replace(/[^0-9a-zA-Z_-]/g, "")
                    //console.log("formatedMethodName search: ", formatedMethodName)
                    methodName = formatedMethodName
                }                  
    
                const flattenTree = (data, parent, tableName) => {
                    data.forEach(({name, data_type, required, attributes, description}) => {

                        // name //todo: rename
                        // http://localhost:8000/api-reference/streaming/#live-streamsstream_idstoptodorename___timestamp__returns

            
                        let formatedName = ''
                        if(name){
                            formatedName = name.toLowerCase().replace(/\s/g, '-').replace(/[^0-9a-zA-Z_-]/g, "")
                        }  

                        //console.log("name: ", name);
                        
                        // we add methodName one time only
                        //const id = parent ? `${parent}--${name.toLowerCase().replace(/\s/g, '-')}__${tableName}` : `${methodName}___${name.toLowerCase().replace(/\s/g, '-')}__${tableName}`                    
                        const id = parent ? `${parent}--${formatedName}__${tableName}` : `${methodName}___${formatedName}__${tableName}`          

                        if(attributes){
                            flattenTree(attributes, id, tableName)
                        }
    
                        let content = ''
                        if(description){
                            content = description.replace(/<[^>]+>/g, '') 
                        }
                        
                        jsonDataArray.push({
                            id: `${id}`,
                            title: name,
                            slug: `${prefix}#${id}`,
                            content: content,
                            prefix: prefix,
                            type: "parameter",
                            http_method: http_method,
                            method:api_method,
                            var_type: data_type,
                            required: required ? "req" : "opt",
                            section: 'Api References'                                      
                        })
    
    
                    })
                }
    
                if(method_arguments){
                    flattenTree(method_arguments, null, 'arguments')
                }  
    
                if(return_object){
                    flattenTree(return_object, null, 'returns')
                }                                
    
                if(input_objects){
                    flattenTree(input_objects, null, 'attributes')
                }
    
                if(output_objects){
                    flattenTree(output_objects, null, 'attributes')
                }                
        
            })              
        })
        
    }    



    // add pages data to sarch index
    let siteNodes = siteMdxData.allMdx.nodes

    siteNodes.forEach( (node, index) => {

        // var anchorTagsRemoved = myString.replace(/<a.*>.*?<\/a>/ig,'');
       
        const mdxRawBodyWithoutH1 = node.rawBody.replace(/<h1.*>.*?<\/h1>/ig,'');
        
        //const mdxRawBody = node.rawBody.replace(/<[^>]+>/g, '') // remove all tags 
        const mdxRawBody = mdxRawBodyWithoutH1.replace(/<[^>]+>/g, '') // remove all tags 
        const { body } = frontmatter(mdxRawBody) 
        let pageContent = body
    
        // SEARCH SECTIONS
        // api-reference   Api References
        // tutorials       Tutorials
        // faq             FAQ
        // support         don't add to search index        

        // analyze node.slug 

        let sectionName = ''        

        if(node.slug.startsWith('api-reference')){
            sectionName = 'Api References'
        }  
        
        if(node.slug.startsWith('tutorials')){
            sectionName = 'Tutorials'
        } 

        if(node.slug.startsWith('faq')){
            sectionName = 'FAQ'
        }  
        
        if(node.slug.startsWith('support')){
            sectionName = 'Support'
        }          
        
        // if frontmatter has redirect we ignore this page and do not include it into search index
        let ignore = node.frontmatter.redirect ? true : false

        if(!ignore){
            jsonDataArray.push({
                id: `page_${index}`,
                title: node.frontmatter.post_title,
                slug: "/"+node.slug,
                //content: pageContent, 
                content: pageContent.substring(0, 100),  
                prefix: '',
                type: "page",
                http_method:'',
                method:'',
                var_type:'',
                required:'',
                section: sectionName            
            })     


            // look for h2 tags with IDs in node.rawBody       
            // ## Receive Callbacks     
            // <h2 id="receive-callbacks" style="position: relative;">Receive Callbacks</h2>

            // ## 4. Define Output Settings 
            // <h2 id="4-define-output-settings" style="position: relative;">4. Define Output Settings</h2>

            //if(node.slug === 'api-reference/transcoding'){
            if(node.slug){
                //console.log("node.slug: ", node.slug)
                //console.log("node.rawBody: ", node.rawBody)

                let pageSections = []

                let rawMarkDown = node.rawBody
                let lines = rawMarkDown.split('\n');

                let titles = lines.filter(line => line.startsWith('## ')).reverse()
                //console.log("titles: ", titles)

                // 1. we find last title in the page and copy everything starting from it to the end to new section
                // 2. after that we remove title and everything below it from the text and repeat step 1

                titles.forEach(title => {

                    let titleIndex = rawMarkDown.indexOf(title)                    
                    let section = rawMarkDown.substring(titleIndex, rawMarkDown.length)

                    let sectionContent = section.substring(title.length, section.length).replace(/<[^>]+>/g, '') // remove all tags 
                    let sectionTitle = title.substring(3, title.length);
                   
                    pageSections.push({
                        id: sectionTitle.toLowerCase().split(' ').join('-').replace(/\./g,''), // id must match id generated for h2 tag, remove all dots
                        title: sectionTitle,
                        content: sectionContent
                    })
                    
                    rawMarkDown = rawMarkDown.substring(0, titleIndex);
                })

                pageSections.reverse()

                //console.log("pageSections: ", pageSections)
                // http://localhost:8000/api-reference/transcoding#error-codes
                // "/tutorials/transcoding/getting-started/launch-a-job/#6.-checking-status"
                //<h2 id="6-checking-status" style="position: relative;">6. Checking Status</h2>

                pageSections.forEach(({title, id, content}, sectionIndex) => {
                    //console.log("title: ", title)
                    jsonDataArray.push({
                        id: `page_section_${index}_${sectionIndex}`,
                        title: title,
                        slug: "/"+node.slug+'/'+"#"+ id,
                        content: content,  
                        prefix: '',
                        type: "page",
                        http_method:'',
                        method:'',
                        var_type:'',
                        required:'',
                        section: sectionName            
                    })                       
                })

                
                                  
            }
        }           

    })


    const dataToSearch = new JsSearch.Search("id")
    //dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()
    //dataToSearch.indexStrategy = new JsSearch.ExactWordIndexStrategy()
    dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy()
    dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer()
    dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("id")

    dataToSearch.addIndex('title')

    dataToSearch.addIndex('content')

    dataToSearch.addIndex('method')

    dataToSearch.addIndex('section')

    dataToSearch.addDocuments(jsonDataArray)         

    //console.log("jsonDataArray: ", jsonDataArray);

    const search = (query) => {
        setQuery(query)  

        let queryResult = dataToSearch.search(query)   
        

        let queryWorsList = query.split(' ');

        queryResult =  queryResult.filter(({title, content, method, section }) => {   

            let found = false;

            queryWorsList.forEach(queryWord => {

                if(title.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }
                
                if(content.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }                  

                if(method.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }     
                
                if(section.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }                   

            })

            return found;
            
        });

        setResults(queryResult)        
    }    

    const searchInput = useRef(null)

    useEffect(() => {

     if(showModal){
        searchInput.current.focus()
     }
    
    }, [showModal])      

    // SEARCH SECTIONS
    // api-reference   Api References
    // tutorials       Tutorials
    // faq             FAQ
    // support         don't add to search index        


    

    const SearchTabsBar = ({results}) => {

        let filteredResults = results

        const tabsInitialState = [
            {
                name: 'Api References',
                selected: true,
                numberOfResults: 0
            },
            {
                name: 'Tutorials',
                selected: false,
                numberOfResults: 0
            },
            // {
            //     name: 'FAQ',
            //     selected: false,
            //     numberOfResults: 0
            // },
            {
                name: 'All',
                selected: false,
                numberOfResults: 0
            }                        
        ]
        const [tabs, setTabs] = useState(tabsInitialState)           

        const updateSelectedTab = (index) => {
            let newTabsStates = [...tabs]
            newTabsStates.map(tab => {
                return tab.selected = false
            })
            newTabsStates[index].selected = true
            setTabs(newTabsStates)          

        }

        useEffect(() => {

            let apiReferencesResults = results.filter( item => item.section === "Api References")
            let tutorialsResults = results.filter( item => item.section === "Tutorials")
            let faqResults = results.filter( item => item.section === "FAQ")

            let newTabsStates = [...tabs]

            // set all number of results
            newTabsStates.map(tab => {
                if(tab.name === "All"){
                    tab.numberOfResults = results.length
                }

                if(tab.name === "Api References"){                
                    tab.numberOfResults = apiReferencesResults.length
                }  

                if(tab.name === "Tutorials"){                
                    tab.numberOfResults = tutorialsResults.length
                }   
                
                if(tab.name === "FAQ"){                
                    tab.numberOfResults = faqResults.length
                }                   
                               
                return tab
            })


            setTabs(newTabsStates) 
    
        }, [results])        

        useEffect(() => {
            // console.log("UPDATE RESULTS")

            // find name of selected tab and filter results filteredResults
            let selectedTabName = tabs.filter( tab => tab.selected === true)[0].name
                     
            if(selectedTabName === "All"){
                filteredResults = results
            } else{
                filteredResults = results.filter(item => item.section === selectedTabName)
            }



        }, [tabs])

        // find name of selected tab and filter results filteredResults
        let selectedTabName = tabs.filter( tab => tab.selected === true)[0].name         
    
        if(selectedTabName === "All"){
            filteredResults = results
        } else{
            filteredResults = results.filter(item => item.section === selectedTabName)
        }        


        const tabsElements = tabs.map( ({name, selected, numberOfResults}, index) => {
            return (
                <div 
                    key={index}
                    className = {
                        selected 
                        ? `${searchStyles.searchTab} ${searchStyles.active}`
                        : searchStyles.searchTab
                    }                    
                    onClick={() => updateSelectedTab(index)}  onKeyDown={() => updateSelectedTab(index)} 
                    role="button" tabIndex="0"                                     
                >
                    {name} ({numberOfResults})
                </div>
            )
        })        

        return (
            <div>

                <div className={searchStyles.tabs}>
                    {tabsElements}
                </div>

                <div className={searchStyles.results}>
                { 
                    filteredResults.length > 0 && 
                        <ul>
                            {filteredResults.map(item => (
                                <li key={item.id}>                      
                                    <Link to={item.slug} onClick={() => setShowModal(false)}>
                                        <div className={searchStyles.resultItem}>
                                            <div className={searchStyles.resultItemHeader}>
                                                
                                                <div className={searchStyles.resultItemHeaderParams}>                                                    
                                                    {
                                                        item.type === "parameter" 
                                                        ?
                                                        <>
                                                            <span className={searchStyles.paramName}>{item.title}</span>
                                                            <span className={searchStyles.paramMethod}>{item.method}</span>
                                                        </>
                                                        : <>{item.title}</>
                                                    }
                                                </div>

                                                {
                                                    item.type === "page" && 
                                                    <div className={searchStyles.pageSectionName}>
                                                        {item.section}
                                                    </div>
                                                }
                                      
                                                {
                                                    item.type === "section" &&
                                                    <div className={searchStyles.sectionDetails}>
                                                        <div className={searchStyles.httpMethod}>{item.http_method}</div>
                                                        <div>{item.method}</div>
                                                    </div>
                                                } 

                                                {
                                                    item.type === "parameter" &&
                                                    <div className={searchStyles.paramDetails}>
                                                        <div className={searchStyles.paramDataType}>{item.var_type}</div>    
                                                        {
                                                            item.required === "req" &&
                                                            <div className={searchStyles.paramReq}>{item.required}</div>                                                               
                                                        } 
                                                        {
                                                            item.required === "opt" &&
                                                            <div className={searchStyles.paramOpt}>{item.required}</div>                                                               
                                                        }                                                                             
                                                    </div>
                                                }                                                             
                                            </div>                                            
                                            {
                                                item.content &&
                                                <div className={searchStyles.resultItemBody}>
                                                    {item.content}
                                                </div>
                                            }
                                        </div>
                                    </Link>

                                </li>
                            ))}
                        </ul>
                }  
                </div>

            </div>            
        )
    }

    // add/remove keydown event handler to the document
    useEffect(() => {
        const keyDownHandleSearch = (e) => {
            if(e.ctrlKey && e.code === "KeyF"){
                e.preventDefault()
                setShowModal(true)
            }
        }

        document.addEventListener("keydown", keyDownHandleSearch)

        // these functions clean up the event listeners
        return () => document.removeEventListener("keydown", keyDownHandleSearch)
    })      
    
    return(       
        <div className={searchStyles.container}>

            <button className={searchStyles.searchBtn} id="search_btn" onClick={() => setShowModal(true)}>
                Search anything
            </button>            
                    
            <Modal id="search" show={showModal} handleClose={() => setShowModal(false)}>

                <div className={searchStyles.header}>
                    <input type="text" ref={searchInput} placeholder="Search anything" value={query} onChange={e => search(e.target.value)} />
                    <div className={searchStyles.resultsCounter}>{results.length} Results</div>
                </div>

                <SearchTabsBar results={results} />

            </Modal>            

          
        </div>
    )
}

